module.exports = {"experienceCloud":"Experience Cloud","touDialogCancelLabel":"刷新内容","touDialogConfirmLabel":"登录并接受条款","touDialogTitle":"Adobe Experience Cloud 使用条款","touTextLine1":"Adobe Experience Cloud 使用条款已更新。","touTextLine2a":"请登录","touTextLine2b":"并接受更新的条款，然后继续。","touTextLine3":"接受条款后，请单击“刷新内容”。"}


//////////////////
// WEBPACK FOOTER
// ./src/components/TermsOfUseDialog/__localization__/TermsOfUseDialog/zh_cn.json
// module id = 921
// module chunks = 0